<template>
  <div>
    <div>


      <div class="row payments-documents-search-bar-container">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>


      <div :class="generatorMainSectionClass">
        <div>
          <CommonTable2
              :table="tableData"
              rowIdentifier="guid"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="paymentsModule.getPaymentDocumentsTotal"
              :totalPages="paymentsModule.getPaymentDocumentsPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :enableRowSelection="false"
          />
        </div>


      </div>


    </div>
    <b-modal
        v-model="showPaymentDocumentModal"
        id="payment-document-form-modal"
        scrollable
        title="Dokument wypłaty"
        title-class="font-18"
        hide-footer
        size="lg"
        style="z-index:100000!important;"
        @hide="closeDocumentModal()"
    >

      <div class="row">
        <div class="paid-payments-action-buttons">
          <button
              v-if="!showPaymentDocumentEditForm"
              class="d-none d-sm-inline-block btn btn-sm btn-edit shadow-sm"
              @click="editPaymentDocument()"
          >
            <i class="fas fa-edit"/>
            Edytuj dokument
          </button>



        <button
              class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
              style="margin-left: 4px;"
              @click="exportAndSendEmail()"

          >
            <i class="fab fa-telegram-plane ms-1"/>
            Wyślij dokumenty do dostawcy
          </button>




        </div>


      </div>

      <div class="row">
        <div class="paid-payments-action-buttons">
          <button
              class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
              style="margin-left: 4px;"
              @click="exportToPDFText()"

          >
            <i class="fas fa-file-pdf"/>
            Eksportuj do PDF
          </button>

          <button
              class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
              style="margin-left: 4px;"
              @click="exportDocumentItemsToCsv()"

          >
            <i class="fas fa-file-excel"/>
            Eksportuj dokumenty do CSV
          </button>

          <button
              class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
              style="margin-left: 4px;"
              @click="openBankWireGenerator()"

          >
            <i class="fas fa-file-invoice-dollar"/>
            Eksportuj do banku
          </button>

        </div>
      </div>
      <div v-if="showPaymentDocumentEditForm" style="margin-top: 20px!important;">


        <div class="row">
          <div class="btn btn-info" @click="showSelectCentralSupplierModal = true">
            <i class="fas fa-file-import"></i>
            Importuj dane dostawcy centralnego
          </div>
        </div>

        <CommonForm id="payment-document-form"
                    :structure="paymentDocumentFormStructure" :data="currentPaymentDocumentFormData"
                    :key="currentPaymentDocumentFormData"
                    @onSubmit="savePaymentDocumentData($event)"
                    @onCancel="cancelPaymentDocumentEdit"
                    submitButtonText="Zapisz" :submitButtonEnabled="true"
                    cancelButtonText="Anuluj" :cancelButtonEnabled="true"
        />

      </div>
      <div v-else>
        <BankWireOrderDocument id="bank-wire-pdf" ref="bank-wire-pdf"
                               :bankWireOrderDocument="currentPaymentDocumentFormData"/>
      </div>

    </b-modal>


    <SupplierListModal :showModal="showSelectCentralSupplierModal"
                       @update:showModal="showSelectCentralSupplierModal = $event"
                       title="Powiąż z centralną kartoteką dostawcy"
                       ok-title="Powiąż"
                       :multiselect="false" @onApply="importSelectedSupplierData" @onClose="showSelectCentralSupplierModal = false"
                       :showMassActions="false"
                       :showRowActions="false"
                       :showAddButton="false"
    />


    <b-modal
        v-model="showSendMailModal"
        id="send-payment-doc-email-form-modal"
        scrollable
        :title=mailContent.sendMailDialogTitle
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer


    >
      <b-alert
          v-model="showSendMailAlert"
          :variant="sendMailAlertType"
          class="mt-3"
          dismissible
      >{{ sendMailAlertContent }}
      </b-alert
      >

      <div class="form-group">

      <CommonEmailSendMessageForm
          :mailMessage="mailContent.mailMessage"
          :mailSubject="mailContent.mailSubject"
          :mailTo="mailContent.mailTo"
          :mailCc="mailContent.mailCc"
          :mailAttachmentName="mailContent.mailAttachmentName"
          @onCancelMail="showSendMailModal = false"
          @onSendMail="sendEmailWithPaymentDocumentData"
          :key="mailContent"


      />


      </div>




    </b-modal>

    <BankWireModal
        v-if="showBankWireGenerator"
        :banks="banks"
        :paymentDocumentGuid="currentPaymentDocumentFormData.guid"
        @onClose="closeBankWireGenerator"
    />



  </div>

</template>


<script>
import CommonTable2 from "@/components/widgets/CommonTable2";

import {BModal} from "bootstrap-vue-next";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import {log} from "@/state/pinia/log";
import CommonForm from "@/components/widgets/CommonForm.vue";
import {paymentFormFields} from "./data/paymentFormFields";
import {paymentsHelperMethods} from "./helper/paymentsHelperMethods";
import BankWireOrderDocument from "./BankWireOrderDocument.vue";
import jsPDF from "jspdf";
import {jsFonts} from "./data/jsFonts";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import Swal from "sweetalert2";
import CommonEmailSendMessageForm from "@/components/widgets/CommonEmailSendMessageForm.vue";
import SupplierListModal from "@/views/DrugstoreCommonManager/SupplierListModal.vue";
import BankWireModal from "./BankWireModal.vue";
import {usePaymentsManagerModule} from "@/state/pinia/paymentsManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {useLayoutStore} from "@/state/pinia/layout";


export default {
  name: "PaymentsDocumentsListStage",
  props: {},
  components: {
    BankWireModal,
    SupplierListModal,
    CommonEmailSendMessageForm,
    BankWireOrderDocument,
    BModal,
    CommonForm,
    // BModal,
    SearchBar2,
    // PaymentConfirmationModal,
    CommonTable2
  },
  data() {
    return {
      tableData: {},
      currentPage: 1,
      sortingDirection: "DESC",
      sortingKey: "createdAt",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      paymentsDocumentsRows: [],
      tableMassActions: [
        {
          text: "Usuń",
          icon: "fas fa-trash-alt", //Usuń
          action: "remove-payment-document",
          enabled: true,
          class: "btn btn-danger mass-operations-btn",
        }


      ],

      fieldsAvailableForSearch: [
        {
          name: "Numer dokumentu płatności",
          key: "documentNumber"
        },
        {
          name: "Nazwa odbiorcy",
          key: "receiverName"
        },

        {
          name: "NIP odbiorcy",
          key: "receiverNip"
        },
        {
          name: "Nazwa płatnika",
          key: "payerName"
        },
        {
          name: "NIP płatnika",
          key: "payerNip"
        },
        {
          name: "Tytuł płatności",
          key: "paymentTitle"
        },


      ],
      availableHeaders: [
        {
          text: "Płatnik",
          key: "payerName",
          type: "text",
          sortable: true,
          style: "width: 100px"

        },
        {
          text: "Numer",
          key: "documentNumber",
          type: "text",
          sortable: true,
          style: "width: 100px"

        },
        {
          text: "Odbiorca",
          key: "receiverName",
          type: "text",
          sortable: true,
          style: "width: 300px"

        },
        {
          text: "Kwota",
          key: "documentValue",
          type: "number",
          sortable: true,

        },
        {
          text: "Data utworzenia",
          key: "createdAt",
          type: "datetime",
          sortable: true,
        },

        {
          text: "Tytuł płatności",
          key: "paymentTitle",
          type: "text",
          sortable: true,
          style: "width: 400px"
        },

        {
          text: "Akcje",
          key: "actions",
          type: "actions",
         actions:[

           {
             text: "",
             icon: "fas fa-file-invoice", //Dokument wypłaty
             action: "view-payment-document",
             enabled: true,
             tooltip: "Zobacz dokument wypłaty",
             class:"btn btn-info table-actions-button edit-button"
           },
            {
                text: "",
                icon: "fas fa-trash", //Usuń
                action: "remove-payment-document",
                enabled: true,
                tooltip: "Usuń dokument",
                class:"btn btn-danger table-actions-button edit-button"
            }

           ]
        }



      ],

      refreshTable: true, //added key to force re-rendering
      showPaymentDocumentModal: false,
      showPaymentDocumentEditForm: false,
      paymentDocumentFormStructure: paymentFormFields.paymentDocumentForm,
      currentPaymentDocumentFormData: {},
      emptyPaymentDocumentFormData: {
        guid: null,
        documentNumber: null,
        documentType: null,
        documentIssueDateTime: null,
        documentValue: null,
        documentCurrency: "PLN",
        receiverName: null,
        receiverAccountNumber: null,
        receiverBankName: null,
        receiverAddress: null,
        receiverNip: null,
        payerName: null,
        payerAccountNumber: null,
        payerBankName: null,
        payerAddress: null,
        payerNip: null,
        paymentTitle: null,
      },
      showSelectCentralSupplierModal: false,
      selectedCentralSuppliersGuidToImport:null,
      mailContent:{
        sendMailDialogTitle: "",
        mailMessage:"" ,
        mailSubject: "",
        mailTo: "",
        mailCc:"",
        mailAttachmentName:""
      },
      showSendMailModal: false,
      showSendMailAlert:false,
      sendMailAlertType: "warning",
      sendMailAlertContent: "",
      showBankWireGenerator:false,
      banks: [],


    };
  },
  computed: {
    paymentsModule(){
      return usePaymentsManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    layoutStore() {
      return useLayoutStore();
    },

    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }

    },

    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row payments-documents-table-container';
      } else {
        return 'payments-documents-table-container';
      }
    },
  },
  methods: {

    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshPaymentsDocumentsData();
    },
    runAction(event) {
      if (event.action.action === "view-payment-document") {
        log.log(event);
        this.refreshSelectedDocumentForm(event.itemData.guid);

      }else if(event.action.action === "remove-payment-document") {
        this.removePaymentDocuments([event.itemData.guid])
      }
    },
    runMassAction(event) {
      log.log(event);
      if (event.action.action === "remove-payment-document") {
        this.removePaymentDocuments(event.items)
      }
    },


    removePaymentDocuments(guids){
      if(guids == null || guids.length === 0){
        return
      }

      var content = "Czy na pewno chcesz usunąć dokument płatności?"
      if(guids.length >1){
        content = "Czy na pewno chcesz usunąć zaznaczone dokumenty płatności?"
      }

      Swal.fire({
        title: "Czy na pewno?",
        text: content,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        dangerMode: true,
      }).then((result) => {
        if (result.value) {

          var removePaymentPayload = {
            documentGuids: guids
          }

          this.paymentsModule.httpRemoveAllPaymentDocumentsByGuid(removePaymentPayload).then(() => {
            this.refreshPaymentsDocumentsData();
          });
        } else {
          // Do nothing...
        }
      });
    },
    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.refreshPaymentsDocumentsData();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      log.log(event.itemsData);
    },

    refreshSelectedDocumentForm(paymentDocumentGuid){
      var viewPaymentPayload ={
        documentGuid: paymentDocumentGuid
      }

      return this.paymentsModule.httpGetPaymentDocumentByGuid(viewPaymentPayload).then((response) => {
        log.log(response);
        if(response.status === 200){
          this.currentPaymentDocumentFormData = JSON.parse(JSON.stringify(response.data.payload));
          // formating document issue date from timestamp to date string
          this.currentPaymentDocumentFormData["documentIssueDateTime"] = paymentsHelperMethods.formatDateToISO(this.currentPaymentDocumentFormData["documentIssueDateTime"]);

          // block some of the fields in form structure, because we want to show them as read-only (not to update)
          // documentNumber, documentType,documentIssueDateTime and documentValue should not be updatable
          // this.paymentDocumentFormStructure is an array we have to iterate by every item to iterate on the fields array
          // also we have to make copy to avoid changing the original structure

          var paymentDocumentFormStructureCopy = JSON.parse(JSON.stringify(this.paymentDocumentFormStructure));

          for (var i = 0; i < paymentDocumentFormStructureCopy.length; i++) {
            if(paymentDocumentFormStructureCopy[i].fields !== undefined){
              for (var j = 0; j < paymentDocumentFormStructureCopy[i].fields.length; j++) {
                if(paymentDocumentFormStructureCopy[i].fields[j].name === "documentNumber" || paymentDocumentFormStructureCopy[i].fields[j].name === "documentType" || paymentDocumentFormStructureCopy[i].fields[j].name === "documentIssueDateTime" || paymentDocumentFormStructureCopy[i].fields[j].name === "documentValue"){
                  paymentDocumentFormStructureCopy[i].fields[j].disabled = true;
                }
              }
            }
          }

          this.paymentDocumentFormStructure = paymentDocumentFormStructureCopy;

          this.showPaymentDocumentModal = true;
        }else if(response.status === 203){
          this.showPaymentDocumentModal = false;
          apiRequestsHelper.handleResponseWithDialogs(response, false);
        }


      }).catch((error) => {
        return apiRequestsHelper.catchResponseError(error,"httpGetPaymentDocumentByGuid");
      });
    },

    refreshPaymentsDocumentsData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o dokumentach płatności.");
      this.paymentsDocumentsRows = JSON.parse(JSON.stringify(this.paymentsModule.getPaymentDocuments));
      this.refreshPaymentsDocumentsList();
    },

    refreshPaymentsDocumentsList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie listy dokumentów płatności.");
      this.paymentsModule.setPayments([])


      this.searchAndFilterRequest = {
        fields: null,
        search: this.searchRequest,
        filters: null
      }

      var payload = {
        searchAndFilterRequest: this.searchAndFilterRequest,
        currentPage: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey,

      };
      this.refreshTable = false;
      this.paymentsModule.httpGetPaymentDocumentsDataPaging(payload).then(() => {
        this.paymentsDocumentsRows = [];
        var paymentsDocuments = JSON.parse(JSON.stringify(this.paymentsModule.getPaymentDocuments));
        for (var i = 0; i < paymentsDocuments.length; i++) {
          paymentsDocuments[i]["createdAt"] = paymentsHelperMethods.formatDatetimeToLocaleFormat(paymentsDocuments[i]["createdAt"]);
          paymentsDocuments[i]["documentValue"] = paymentsDocuments[i]["documentValue"].toFixed(2);
          paymentsDocuments[i]["tooltip"] = this.commonModule.getDrugstoresNameMap[paymentsDocuments[i]["id_apteki"]];

          this.paymentsDocumentsRows.push(paymentsDocuments[i]);
        }


        this.tableData['headers'] = this.availableHeaders;

        this.tableData['massActions'] = this.tableMassActions;

        this.tableData['data'] = this.paymentsDocumentsRows;
        this.refreshTable = true;


      });
    },


    savePaymentDocumentData(event) {

      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Zapisywanie zmian w dokumencie");

      var updatePayload = {
        paymentDocument: event,
        documentGuid: this.currentPaymentDocumentFormData.guid
      }
      this.paymentsModule.httpUpdateDocuments(updatePayload).then(() => {
        this.showPaymentDocumentModal = false;
        this.currentPaymentDocumentFormData = JSON.parse(JSON.stringify(this.emptyPaymentDocumentFormData));
        this.showPaymentDocumentEditForm = false;
        this.refreshPaymentsDocumentsData();
      })


    },
    exportToPDFText() {

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4"
      });
      // Adding the font which supports Polish characters
      var arialNormalFont = jsFonts.ArialNormalJs;
      pdf.addFileToVFS('arial-normal.ttf', arialNormalFont);
      pdf.addFont('arial-normal.ttf', 'arial', 'normal');
      pdf.setFont("arial");

      // Add title
      pdf.setFontSize(16);

      pdf.text("Zlecenie Przelewu Bankowego", 40, 40);


      // Add document details

      pdf.setFontSize(12);
      pdf.text(`Numer dokumentu: ${this.currentPaymentDocumentFormData.documentNumber || '---'}`, 40, 80);
      pdf.text(`Typ dokumentu: ${this.currentPaymentDocumentFormData.documentType || '---'}`, 40, 100);
      pdf.text(`Data wystawienia: ${paymentsHelperMethods.formatDateToLocale(this.currentPaymentDocumentFormData.documentIssueDateTime) || '---'}`, 40, 120);

      // Horizontal separator line
      pdf.line(10, 150, 300, 150);


      // Add payer details
      pdf.setFontSize(14);
      pdf.text("Dane płatnika", 40, 180);
      pdf.setFontSize(12);
      pdf.text(`Nazwa: ${this.currentPaymentDocumentFormData.payerName || '---'}`, 40, 200);
      pdf.text(`Numer konta: ${this.currentPaymentDocumentFormData.payerAccountNumber || '---'}`, 40, 220);
      pdf.text(`Nazwa banku: ${this.currentPaymentDocumentFormData.payerBankName || '---'}`, 40, 240);
      pdf.text(`Adres: ${this.currentPaymentDocumentFormData.payerAddress || '---'}`, 40, 260);
      pdf.text(`NIP: ${this.currentPaymentDocumentFormData.payerNip || '---'}`, 40, 280);
      // Horizontal separator line
      pdf.line(10, 290, 300, 290);


      // Add receiver details
      pdf.setFontSize(14);
      pdf.text("Dane odbiorcy", 40, 320);
      pdf.setFontSize(12);
      pdf.text(`Nazwa: ${this.currentPaymentDocumentFormData.receiverName || '---'}`, 40, 340);
      pdf.text(`Numer konta: ${this.currentPaymentDocumentFormData.receiverAccountNumber || '---'}`, 40, 360);
      pdf.text(`Nazwa banku: ${this.currentPaymentDocumentFormData.receiverBankName || '---'}`, 40, 380);
      pdf.text(`Adres: ${this.currentPaymentDocumentFormData.receiverAddress || '---'}`, 40, 400);
      pdf.text(`NIP: ${this.currentPaymentDocumentFormData.receiverNip || '---'}`, 40, 420);

      // Add payment title
      pdf.setFontSize(12);
      pdf.text(`Kwota: ${this.formatCurrency(this.currentPaymentDocumentFormData.documentValue) || '---'} ${this.currentPaymentDocumentFormData.documentCurrency}`, 40, 460);
      pdf.text(`Słownie: ${paymentsHelperMethods.numberToTextPLN(this.currentPaymentDocumentFormData.documentValue) || '---'} `, 40, 480);
      pdf.text(`Tytuł płatności:`, 40, 500);
      pdf.text(`${this.breakTextAfterEveryNChars(this.currentPaymentDocumentFormData.paymentTitle, 60) || '---'}`, 60, 520);

      // pdf.line(0, 540, 1000, 540);
      // Save the PDF
      pdf.save(`Zlecenie_Przewlewu_${this.currentPaymentDocumentFormData.documentNumber || 'dokument'}.pdf`);
    },

    breakTextAfterEveryNChars(text, n) {
      if (text === null) return null;
      return text.match(new RegExp('.{1,' + n + '}', 'g')).join('\n');
    },

    formatCurrency(value) {
      if (value === null) return null;
      return Number(value).toFixed(2);
    },
    editPaymentDocument() {
      this.showPaymentDocumentEditForm = true;
    },
    closeDocumentModal() {
      log.log("closing document modal");
      this.showPaymentDocumentEditForm = false;
    },
    cancelPaymentDocumentEdit() {

      this.refreshSelectedDocumentForm(this.currentPaymentDocumentFormData.guid).then(() => {
        this.showPaymentDocumentEditForm = false;
      });

    },


    importSelectedSupplierData(suppliers){
      if (suppliers== null || suppliers.length === 0) {
        return;
      }

      this.selectedCentralSuppliersGuidToImport = suppliers[0].guid;
      var selectedSupplierPayload = {
        guid: this.selectedCentralSuppliersGuidToImport
      }
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Importowanie danych wybranego dostawcy centralnego...");

      this.commonModule.httpGetSupplierByGuid(selectedSupplierPayload).then((response) => {
        if (response.status === 200) {
          const importedSupplier = response.data.payload;

          this.currentPaymentDocumentFormData.receiverName = importedSupplier.name;
          this.currentPaymentDocumentFormData.receiverNip = importedSupplier.nip;
          this.currentPaymentDocumentFormData.receiverAccountNumber = importedSupplier.bankAccount;
          this.currentPaymentDocumentFormData.receiverBankName = importedSupplier.bankName;
          this.currentPaymentDocumentFormData.receiverAddress = importedSupplier.address + ", " + importedSupplier.zipcode + " " + importedSupplier.city;

          this.showSelectCentralSupplierModal = false;
          this.showPaymentDocumentEditForm = false;
          // thread sleep for form reload:
          setTimeout(() => {
            this.showPaymentDocumentEditForm = true;
          }, 100);
          this.lazyloaderModule.setDisplayLazyLoader(false)
        }
      })
    },
    exportAndSendEmail(){
      paymentsHelperMethods.exportDocumentItemsToFile(this.currentPaymentDocumentFormData.guid,"CSV",true,false).then((response)=>{
        log.log(response);
        if(response.isConfirmed){
          this.mailContent = {
            sendMailDialogTitle: response.sendMailDialogTitle,
            mailMessage: response.mailMessage,
            mailSubject: response.mailSubject,
            mailTo: response.mailTo,
            mailCc:response.mailCc,
            mailAttachmentName: response.mailAttachmentName
          }

          const messageAlreadySentForThisDocument = this.currentPaymentDocumentFormData.sentMessageHistory
          if(messageAlreadySentForThisDocument && messageAlreadySentForThisDocument.sent === true){
            this.showSendMailAlert = true;
            this.sendMailAlertType = "warning";
            this.sendMailAlertContent = "Wiadomość email z dokumentem została już wysłana do dostawcy dnia " + paymentsHelperMethods.formatDatetimeToLocaleFormat(messageAlreadySentForThisDocument.sendDate);
          }

          this.showSendMailModal = true;

        }
      });
    },

    openBankWireGenerator(){
      if(this.currentPaymentDocumentFormData && this.currentPaymentDocumentFormData.documentValue && (this.currentPaymentDocumentFormData.documentValue < 0 || this.currentPaymentDocumentFormData.documentValue === 0)){
        Swal.fire({
          title: "Nieprawidłowa wartość dokumentu",
          text: "Nie można wyeksportować do formatu bankowego dokumentu z ujemną lub równą 0 wartością.",
          icon: "error",
          customClass: {
            container: "swal-highest"
          },

        })
        return
      }



      this.showBankWireGenerator = true;
    },
    closeBankWireGenerator(){
      this.showBankWireGenerator = false;
    },



    exportDocumentItemsToCsv(){
      paymentsHelperMethods.exportDocumentItemsToFile(this.currentPaymentDocumentFormData.guid,"CSV",true,true).then((response)=>{
        log.log(response);
        if(response.isConfirmed){
          this.mailContent = {
            sendMailDialogTitle: response.sendMailDialogTitle,
            mailMessage: response.mailMessage,
            mailSubject: response.mailSubject,
            mailTo: response.mailTo,
            mailCc:response.mailCc,
            mailAttachmentName: response.mailAttachmentName
          }

          this.showSendMailModal = true;

        }
      });
    },

    sendEmailWithPaymentDocumentData(emailData){
      log.log(emailData);
        this.lazyloaderModule.setDisplayLazyLoader(true);
        this.lazyloaderModule.setProgressBarMessage("Wysyłanie wiadomości email z listą dokumentów...");

        var emailPayload = {
          mailMessage: emailData,
          paymentDocumentGuid: this.currentPaymentDocumentFormData.guid
        }

        this.paymentsModule.httpSendEmailWithPaymentDocumentData(emailPayload).then((response) => {
          this.showSendMailModal = false;
          return apiRequestsHelper.handleResponseWithDialogs(response, true);
        })
            .catch((error) => {
              return apiRequestsHelper.catchResponseError(error,"httpSendEmailWithPaymentDocumentData");
            });
      }

  },
  watch: {
    currentPage: {
      handler() {
        this.refreshPaymentsDocumentsData();

      },
      deep: true,
    },


  },
  mounted() {

  },
  created() {
    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();
    this.refreshPaymentsDocumentsData();
    this.paymentsModule.httpGetAvailableBanks().then(()=>{
      
      //  { key: "santander", name: "Santander Bank Polska S.A.", icon: "images/santander.png" }
      const fetchedAvailableBanks = JSON.parse(JSON.stringify(this.paymentsModule.getAvailableBanks));
      for (let i in fetchedAvailableBanks) {



        this.banks.push({
          key:fetchedAvailableBanks[i].key,
          name:fetchedAvailableBanks[i].name,
          icon: `images/${fetchedAvailableBanks[i].key.toString().toLowerCase()}.png`
        })

        
      }
      
      
    });

  },
};
</script>

<style scoped>
.payments-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.payments-documents-search-bar-container{
margin-top: 8px;
}

.payments-documents-table-container {
}

.paid-payments-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}


.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

</style>
